import { CpRefundDetailInterface, DocumentInterface } from '../../../../interfaces/response/refunds/refund-detail/cp-refund-detail-interface';

export class CpRefundDetailModel implements CpRefundDetailInterface {
  CardNumber: string = '';
  ClaimStatus: string = '';
  ClaimType: string = '';
  ClinicCase: string = '';
  Contact: string = '';
  DateOfTreatment: string = '';
  Documents?: DocumentInterface[] = new Array<DocumentInterface>();
  Email: string = '';
  IsProcessStateAditionalInformation: boolean = false;
  PersonName: string = '';
  PracticeName: string = '';
  ReceivedDate: string = '';
  RefundReceipt: string = '';
  ServiceName: string = '';
  TotalCoPayment: number = 0;
  TotalDeductible: number = 0;
  TotalInsurer: number = 0;
  TotalValue: number = 0;
}
